import { GoogleIcon } from "#components/ui/GoogleIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const googleManifest: IntegrationManifest = {
    key: "google",
    displayName: "Google",
    nameKey: "channels.google",
    descriptionKey: "googleDescription",
    trayDescriptionKey: "composerTrayDescriptions.google",
    cardDescriptionKey: "connectIntegration.descriptions.google",
    connectedContentKeys: ["googleFiles", "googleEmails", "googleCalendar"],
    brandColor: "#1A73E8",
    iconUrl: IconAssets.Google,
    iconUrlAlt: IconAssets.GoogleAlt,
    glyph: GoogleIcon,
    channelType: "UserGoogle",
    dataSources: ["google_drive_file", "google_calendar_event", "gmail_message"]
};
